import React, { useState, useEffect } from "react";
import Instance from "../../../Services/Instance";
import config from "../../../Services/config";
import { X } from "lucide-react";
import "../../../Assets/Styles/NetflixList.css"

const DetailsPopup = ({ onClose, row }) => {
    const [license, setLicense] = useState([]);
    const [loading, setLoading] = useState(false);


    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await Instance.get(`${config.api_url}/show-license/${row._id}`)
            setLicense(result.data.license);
        } catch (error) {
            console.log("Erreur lors de la recupération de cette license", error);
        }finally {
            setLoading(false);
        }
    }
    const convertChar = (emailString) => {
        if (emailString) {
            const index = emailString.indexOf("undefined") + "undefined".length + 2; // Trouver l'index du premier "undefined" et ajouter sa longueur
            if (index > 1) {
                const extractedString = emailString.substring(index);
                return extractedString;
            }
        }
        return emailString;
    };

    useEffect(() => {
        fetchData();
    }, [row._id]);

    const statusStyles = {
        available: "netflix-bg-green-100 netflix-text-green-600 netflix-border-green-500",
        expired: "netflix-bg-red-100 netflix-text-red-600 netflix-border-red-500",
        sold: "netflix-bg-yellow-100 netflix-text-yellow-600 netflix-border-yellow-500",
    };

    return (
        <div className="netflix-popup-overlay">
            <div className="netflix-popup">
                <div className="netflix-popup-header">
                    <div onClick={onClose} className="netflix-close-btn">
                        <X />
                    </div>
                </div>
                <div className="netflix-popup-content">
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">ID :</span>
                        <span className="netflix-popup-value">{license._id}</span>
                    </div>

                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Nom de la licence :</span>
                        <span className="netflix-popup-value">{license.name}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Produit :</span>
                        <span className="netflix-popup-value">{license.productName}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Catégorie :</span>
                        <span className="netflix-popup-value">{license.productCategory}</span>
                    </div>
                    {license.productTypeSmart && (
                        <div className="netflix-popup-item">
                            <span className="netflix-popup-label">Type d'abonnement Netflix :</span>
                            <span className="netflix-popup-value">{license.productTypeSmart}</span>
                        </div>
                    )}
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Status :</span>
                        <span className={`netflix-popup-value netflix-status ${statusStyles[license?.status]}`}>
                            {license.status}
                        </span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Date de l'ajout :</span>
                        <span className="netflix-popup-value">{new Date(license.creationDate).toLocaleDateString()}</span>
                    </div>
                    {license.expiration && (
                        <div className="netflix-popup-item">
                            <span className="netflix-popup-label">Date d'Expiration :</span>
                            <span className={`netflix-popup-value netflix-status ${statusStyles[license?.status]}`}>
                                {new Date(license.expiration).toLocaleDateString()}
                            </span>
                        </div>
                    )}
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Nombre de comptes disponibles :</span>
                        <span className="netflix-popup-value">{license.number}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Terme :</span>
                        <span className="netflix-popup-value">{license.policy}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">N° de commandes :</span>
                        <span className="netflix-popup-value">{convertChar(license.orderNumber)}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Emails utilisateurs :</span>
                        <span className="netflix-popup-value">{convertChar(license.userEmail)}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Nom Utilisateurs :</span>
                        <span className="netflix-popup-value">{convertChar(license.userName)}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">N° Tel Utilisateurs :</span>
                        <span className="netflix-popup-value">{convertChar(license.userNumberPhone)}</span>
                    </div>
                    <div className="netflix-popup-item">
                        <span className="netflix-popup-label">Accès du Compte :</span><br />
                        <span className={`netflix-popup-value netflix-status`}>
                            {license.key}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailsPopup;
